// The daily challenge done (Design §11.1, Wunsch User 2026-10-28): a banner for its player.

/** Reward points of the daily challenge (`crates/server/src/challenge.rs` REWARD). */
export const CHALLENGE_REWARD = 5;
/** How long the banner stays. */
export const CHALLENGE_BANNER_MS = 2800;

/**
 * The banner at screen pixels `x`, `y` with text height `size`, `t` 0..1 of its time:
 * „DAILY CHALLENGE COMPLETE!“ in glowing gold, below the reward; pops in, fades out.
 */
export function drawChallengeDone(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, t: number, now: number): void {
  ctx.save();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineJoin = 'round';
  // In with a little overshoot in the first 0.25 s, out in the last fifth.
  const ms = t * CHALLENGE_BANNER_MS;
  const pop = ms < 250 ? 0.6 + 0.5 * Math.sin((ms / 250) * (Math.PI * 0.75)) : 1;
  ctx.globalAlpha = t < 0.8 ? 1 : (1 - t) / 0.2;
  const big = Math.round(size * pop * (1 + 0.03 * Math.sin(now / 110)));
  ctx.font = `${big}px 'Black Ops One', Impact, sans-serif`;
  ctx.lineWidth = big * 0.12;
  ctx.strokeStyle = '#3a2800';
  ctx.strokeText('DAILY CHALLENGE COMPLETE!', x, y);
  ctx.shadowColor = '#ffe27a';
  ctx.shadowBlur = big * 0.4;
  ctx.fillStyle = '#ffd54a';
  ctx.fillText('DAILY CHALLENGE COMPLETE!', x, y);
  ctx.shadowBlur = 0;
  const small = Math.round(size * 0.5 * pop);
  ctx.font = `600 ${small}px 'Oswald', 'Arial Narrow', sans-serif`;
  ctx.lineWidth = small * 0.18;
  const reward = `+${CHALLENGE_REWARD} reward points`;
  ctx.strokeText(reward, x, y + size * 0.9);
  ctx.fillStyle = '#fff6c2';
  ctx.fillText(reward, x, y + size * 0.9);
  // Sparkles round the line, gold with a dark rim to show on light ground too.
  ctx.fillStyle = '#ffc928';
  ctx.strokeStyle = '#6b4a00';
  ctx.lineWidth = 1;
  const width = ctx.measureText('DAILY CHALLENGE COMPLETE!').width * (big / small);
  for (let k = 0; k < 14; k++) {
    const a = k * 2.4 + now / 400;
    const blink = 0.5 + 0.5 * Math.sin(now / 80 + k * 1.9);
    const s = (2 + 3 * blink) * (size / 40);
    const [sx, sy] = [x + Math.cos(a) * width * 0.55 - s / 2, y + Math.sin(a * 1.3) * size * 0.8 - s / 2];
    ctx.strokeRect(sx, sy, s, s);
    ctx.fillRect(sx, sy, s, s);
  }
  ctx.restore();
}
